<template>
    <div class="flex flex-wrap items-center">
        <div>
            <i class="fad fa-tags"></i>
            <span class="font-bold mr-1">Tags:</span>
        </div>
        <div class="flex  px-2 rounded items-center">
            <i class="fad mr-1" :class="loading === 'addTag' ? 'fa-spinner fa-spin' : 'fa-plus-circle'"></i>
            <v-select v-model="tagToAdd" :close-on-select="false" :clear-on-select="true" :clear-on-blur="true" :options="Object.values(tags)" label="name" class="w-56 bg-white" @input="addTag()" ref="tagselect">
                <template v-slot:option="option">
                    <div class="truncate">
                        <i class="fal" :class="option.categoryIcon"></i>
                        {{ option.name }}
                    </div>
                </template>
            </v-select>
        </div>
        <a v-for="(tag) in tagsSelected"
            :key="tag.id"
            class="group mr-1 mb-1 px-3 mt-1 py-1 rounded bg-teal-200 cursor-pointer hover:line-through"
            @click.prevent="removeTag(tag)"
        >
            <i class="fal mr-1" :class="loading === 'removeTag'+tag.id ? 'fa-spinner fa-spin' : tag.categoryIcon"></i>{{ tag.name }}
        </a>
    </div>
</template>

<script>

// import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import hotkeys from "hotkeys-js";

export default {

    components: { vSelect },
    
    props: {
        tags: Array,
        tagsSelected: Array,
        loading: ''
    },

    data() {
        return {
            tagToAdd: "",
        };
    },

    methods: {
        
        addTag() {
            this.$emit("tag-added", this.tagToAdd);
            this.tagToAdd = "";
        },

        removeTag(tag) {
            this.$emit("tag-removed", tag);
        },

    },

     mounted() {
        
        hotkeys.filter = function(event){
            return true;
        }
        const tagInput = this.$refs.tagselect.$refs.search;
        hotkeys("cmd+3", function(event, handler) {
            event.preventDefault();
            tagInput.focus();
            return false
        });
        
    }
};
</script>


<style scope="scoped">
    .v-select .vs__selected-options {
        flex-wrap: wrap;
    }
    .v-select .vs__dropdown-menu li {
        @apply px-2;
    }
</style>